import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  Button,
  MenuItem,
} from "@mui/material";
import dayjs from "dayjs";

export default function AddDemoLinkDialog({
  open,
  handleClose,
  onSubmit,
  editMode,
  initialData,
}) {
  const initialState = {
    subject: "",
    teacher: "",
    date: "",
    startTime: "",
    endTime: "",
    meetLink: "",
    status: "Active",
  };

  const [form, setForm] = useState(initialState);

  // Fill form while editing
  useEffect(() => {
    if (open) {
      if (editMode && initialData) {
        setForm({
          subject: initialData.subject || "",
          teacher: initialData.teacher || "",
          date: initialData.date || "",
          startTime: initialData.startTime || "",
          endTime: initialData.endTime || "",
          meetLink: initialData.meetLink || "",
          status: initialData.status || "Active",
        });
      } else {
        setForm(initialState);
      }
    }
  }, [open, editMode, initialData]);


  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async () => {
    if (
      !form.subject ||
      !form.teacher ||
      !form.date ||
      !form.startTime ||
      !form.endTime ||
      !form.meetLink
    ) {
      alert("Please fill all fields");
      return;
    }
    if (
      dayjs(`2000-01-01 ${form.endTime}`).isBefore(
        dayjs(`2000-01-01 ${form.startTime}`)
      )
    ) {
      alert("End Time should be greater than Start Time");
      return;
    }

    await onSubmit(form);
    setForm(initialState);
  };

  const handleCancel = () => {
    setForm(initialState);
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle sx={{ fontWeight: 700 }}>
        {editMode ? "Edit Demo Link" : "Add Demo Link"}
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={2} mt={0.5}>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Subject"
              name="subject"
              value={form.subject}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Teacher Name"
              name="teacher"
              value={form.teacher}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              type="date"
              label="Date"
              name="date"
              value={form.date}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              type="time"
              label="Start Time"
              name="startTime"
              value={form.startTime}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              type="time"
              label="End Time"
              name="endTime"
              value={form.endTime}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Google Meet Link"
              name="meetLink"
              value={form.meetLink}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              select
              fullWidth
              label="Status"
              name="status"
              value={form.status}
              onChange={handleChange}
            >
              <MenuItem value="Active">Active</MenuItem>
              <MenuItem value="Inactive">Inactive</MenuItem>
            </TextField>
          </Grid>

        </Grid>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button
          variant="outlined"
          onClick={handleCancel}
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          onClick={handleSubmit}
          sx={{
            background: "linear-gradient(90deg,#8E2DE2,#C94BFF)",
            textTransform: "none",
          }}
        >
          {editMode ? "Update Demo Link" : "Add Demo Link"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}